<div class="table-top-container clearfix">
    <!-- TOP LEFT -->
    <div class="top-left-container form-inline">
        <!-- Show/hide button -->
        @if (canShowHideColumns) {
            <pcg-button-hide-show [columnDefs]="columnDefs" class="mt-2 mr-2" id="backupId"></pcg-button-hide-show>
        }
        <!-- Filters button -->
        @if (filterId) {
            <pcg-button-filter id="pcg-button-filter" class="mt-2 mr-2" [filterId]="filterId"></pcg-button-filter>
        }
        <!-- Reset filters button -->
        @if (showResetFilterBtn()) {
            <pcg-button-reset-filter class="mt-2 mr-2"></pcg-button-reset-filter>
        }
        <!-- Applied filters -->
        @if (filterMap && btnFilterService.getActiveFilters(ajaxData, filterMap)) {
            <div class="applied-filters-ctnr">
                <div class="applied-filters form-inline alert-success form-control-sm mt-2" role="alert">
                    Applied Filters: {{ btnFilterService.getActiveFilters(ajaxData, filterMap) }}
                </div>
            </div>
        }
    </div>

    <!-- TOP RIGHT -->
    <div class="top-right-container">
        <!-- Table actions -->
        <div id="pageActions">
            @if (hasTooltips && isMobile) {
                <button ngbTooltip="Column Tooltips" (click)="tooltipButtonClicked()" class="new-page-action mt-2">
                    <fa-icon [icon]="faIconName.faQuestion" class="page-action-icon"></fa-icon>
                </button>
            }
            @if (canExportTableToExcel) {
                <button ngbTooltip="Export to Excel" (click)="table.getExcel()" class="new-page-action mt-2">
                    <img src="assets/images/actions/xlsxgreen.svg" class="page-action-icon" />
                </button>
            }
        </div>
        <!-- Table search -->
        @if (canGlobalSearch) {
            <div class="search-container form-inline">
                <input
                    aria-label="Table search"
                    type="search"
                    class="form-control form-control-sm hide-on-print mt-2"
                    placeholder="Search..."
                    (keyup)="filterSource.next($event.target.value)"
                    (click)="clearSearch($event)"
                />
            </div>
        }
    </div>

    <!-- Column tooltip modal -->
    <ng-template #tooltipModal let-modal>
        <div class="modal-header">
            <h5>Column Tooltips</h5>
            <button type="button" class="close" aria-label="Close" (click)="modal.dismiss()">
                <span aria-hidden="true">&times;</span>
            </button>
        </div>
        <div class="modal-body flex-body">
            <pcg-table-top-tooltip [innerHTML]="tooltipContent"></pcg-table-top-tooltip>
        </div>
    </ng-template>
</div>
